<template>
  <div class="zhaopin-zhiwei">
    <c-table
      ref="table"
      :fields="fields"
      :columns="columns"
      url="/zhaopin/zhiwei2"
      @before-fetch="beforeFetch"
    >
      <template #operate>
        <el-button type="primary" @click="model = {}">新增职位</el-button>
      </template>
      <el-table-column slot="zhiwei_name" label="职位名" class-name="pointer" width="140">
        <template v-slot="{row}">
          <div @click="jobInfo(row)">
            <span>{{row.zhiwei_name}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column slot="bumen" show-overflow-tooltip label="部门">
        <template v-slot="{row}">
          <span>{{row | bumen}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="jianli" label="简历数">
        <template v-slot="{row}">
          <el-button
            type="text"
            @click="$router.push(`/resume?id=${row.zhiwei_id}`)"
          >{{row.$zhiwei_jianlis}}份简历</el-button>
        </template>
      </el-table-column>
      <el-table-column slot="shangchuan" label="上传简历">
        <template v-slot="{row}">
          <el-button size="mini" @click="upload(row)" :loading="row.loading">上传</el-button>
        </template>
      </el-table-column>
      <el-table-column slot="caozuo" label="操作" fixed="right" width="200">
        <template v-slot="{row}">
          <el-button
            type="text"
            @click="operate(row, $event)"
          >{{row.zhiwei_zhiding === 1 ? '取消' : ''}}置顶</el-button>
          <el-button
            type="text"
            @click="operate(row, $event, 'neitui')"
          >{{row.zhiwei_neitui === 1 ? '取消' : ''}}内推</el-button>
          <el-dropdown>
            <span class="el-dropdown-link">
              <el-button type="text">
                <span>更多</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="model = row;">编辑</el-dropdown-item>
              <el-dropdown-item @click.native="jobInfo(row)">岗位描述</el-dropdown-item>
              <el-dropdown-item @click.native="remove(row, $event)">停招</el-dropdown-item>
              <el-dropdown-item @click.native="email(row, $event)">发送邮件</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </c-table>
    <edit v-model="model"></edit>
    <el-upload
      style="display:none;"
      ref="upload"
      :show-file-list="false"
      action="/api/zhaopin/zhiwei/uploadjianli2"
      :data="{zhiwei_id:currentJob.zhiwei_id}"
      :before-upload="() => $set(currentJob, 'loading', true)"
      :on-success="onSuccess"
      :on-error="onError"
    ></el-upload>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :show-close="false"
    >
      <div class="upload-tip"><i class="el-icon-warning"></i>已存在相同简历，是否继续上传？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lookOver">查看</el-button>
        <el-button type="warning" @click="deleteJianli(current_jianli_id)">放弃</el-button>
        <el-button type="primary" @click="confirmUpload">保留</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import DepartmentCascade from '@/components/service/department-cascade'
import Edit from './#zhiwei-edit'
import mixin from '@/mixins'
import * as Api from '@/api'

export default {
  name: 'zhaopin-zhiwei',
  mixins: [ mixin ],
  components: { CTable, Edit },
  data () {
    return {
      fields: [
        {
          prop: 'department',
          placeholder: '部门',
          component: DepartmentCascade,
          value: []
        }
      ],
      columns: [
        { slot: 'zhiwei_name' },
        { slot: 'bumen' },
        { prop: 'zhiwei_jibie', label: '级别', width: 100 },
        { prop: 'zhiwei_number', label: '人数', width: 80 },
        { slot: 'jianli' },
        { slot: 'shangchuan' },
        { slot: 'caozuo' }
      ],
      model: null,
      currentJob: {},
      current_jianli_id: '',
      sanme_name_jianli_id: [],
      dialogVisible: false
    }
  },
  methods: {
    upload (job) {
      this.currentJob = job
      this.$refs.upload.$refs[ 'upload-inner' ].$refs.input.click()
    },
    beforeFetch (params) {
      [ (params.jiagou_first), (params.jiagou_second), (params.jiagou_third), (params.jiagou_forth) ] = params.department
      delete params.department
    },
    onSuccess (response) {
      this.currentJob.loading = false
      const { jianli_id, sanme_name_jianli_id = [] } = response
      this.current_jianli_id = jianli_id
      this.sanme_name_jianli_id = sanme_name_jianli_id
      if (sanme_name_jianli_id.length > 0) {
        this.dialogVisible = true
        return false
      }
      this.$notify.success({
        title: '成功',
        message: '上传成功'
      })
      this.$refs.table.reload()
    },
    onError () {
      this.$notify.error({
        title: '失败',
        message: '上传失败'
      })
    },
    operate (row, event, operate = 'up') {
      const key = operate === 'up' ? 'zhiwei_zhiding' : 'zhiwei_neitui'
      this.$_confirm({
        operateText: event.target.innerText,
        name: row.zhiwei_name,
        operate: () =>
          this.$http.post(`/zhaopin/zhiwei/${row[ key ] === 1 ? 'not' : ''}${operate}2`, {
            zhiwei_id: row.zhiwei_id
          }),
        callback () {
          row[ key ] = row[ key ] === 1 ? 0 : 1
        }
      })
    },
    remove (row, event) {
      this.$_confirm({
        operateText: event.target.innerText,
        name: row.zhiwei_name,
        operate: () =>
          this.$http.post(`/zhaopin/zhiwei/delete2`, {
            zhiwei_id: row.zhiwei_id
          }),
        callback: () => {
          this.$refs.table.reload()
        }
      })
    },
    email (row, event) {
      this.$_confirm({
        operateText: event.target.innerText,
        name: row.zhiwei_name,
        operate: () =>
          this.$http.post('/zhaopin/notice', {
            zhiwei_id: row.zhiwei_id
          })
      })
    },
    confirmUpload() {
      this.dialogVisible = false
      this.$refs.table.reload()
    },
    deleteJianli(jianli_id) {
      Api.zhaopin.deleteJianli({ jianli_id }).then(res => {
        const { status } = res.data
        if (status === 'success') this.confirmUpload()
      })
    },
    lookOver() { // 查看最近两份
      if (this.sanme_name_jianli_id.length < 3) {
        this.sanme_name_jianli_id.forEach(item => {
          window.open(`/review/operable/${item}`)
        })
      } else {
        this.sanme_name_jianli_id.slice(-2).forEach(item => {
          window.open(`/review/operable/${item}`)
        })
      }
    }
  }
}
</script>

<style lang="scss">
.zhaopin-zhiwei {
  .el-dropdown {
    margin-left: 10px;
  }
  .upload-tip{
    display: flex;
    justify-content: center;
    align-items: center;
    .el-icon-warning{
      font-size:24px;
      color: #E6A23C;
      margin-right: 5px;
    }
  }
}
</style>
